module.exports = __webpack_public_path__ + "static/media/aw.5c17cef7.svg";